module.exports = __webpack_public_path__ + "static/gap2-1-034ca3a38e1fedc01c7570ebf0c5c138.jpg";